export default {
      id: "icon-export-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "./icon/icons.svg#icon-export",
      toString: function () {
        return this.url;
      }
    }